import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';
import { useCaseBuilderContext } from '../../context/CaseBuilderContext';
import SwapIcon from '../../../../icons/SwapIcon';

const CarouselContainer = styled.div`
	display: none;

	${EmotionBreakpoint('mobile')} {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		position: relative;
	}
	${EmotionBreakpoint('tablet')} {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		position: relative;
	}
`;

const TrackWrapper = styled.div`
	flex: 1;
	overflow: hidden;
`;

const Track = styled.div`
	display: flex;
	transition: transform 0.3s ease-out;
	transform: translateX(${(props) => props.offset}px);
`;

const Slide = styled.div`
	flex: 0 0 100%;
	min-width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 24px;
`;

const CarouselNavButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	border: none;
	background: transparent;
	cursor: pointer;
	flex-shrink: 0;
	transition: opacity 0.3s ease;
	padding: 0;
	border: 1px solid #bcbcbc;
	border-radius: 50px;
	svg {
		max-width: 30px;
	}

	&:disabled {
		opacity: 0.2;
		cursor: not-allowed;
	}
`;

const BottleImageContainer = styled.div`
	transition: opacity 0.3s ease;
	opacity: ${({ active }) => (active ? 1 : 0.3)};
`;

const BottleImage = styled.img`
	width: auto;
	max-height: 198px;
	max-width: 44px;
	object-fit: contain;

	${EmotionBreakpoint('mobile')} {
		max-height: 70px;
	}
	${EmotionBreakpoint('tablet')} {
		max-height: 170px;
	}
`;

const MobileBottleCarousel = () => {
	const {
		wineSlots,
		activeBottleIndex,
		mobileBottleOffset,
		handlePrev,
		handleNext,
		handleBottleSwap,
		bottleSlideRefs,
		touchHandlers,
	} = useCaseBuilderContext();

	return (
		<CarouselContainer {...touchHandlers}>
			<CarouselNavButton
				onClick={handlePrev}
				disabled={activeBottleIndex === 0}
				aria-label='Previous bottle'
			>
				<svg
					width='44'
					height='44'
					viewBox='0 0 44 44'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M27.5 33L16.5 22L27.5 11'
						stroke='#222222'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			</CarouselNavButton>

			<TrackWrapper>
				<Track offset={mobileBottleOffset}>
					{wineSlots.slice(0, 12).map((wineData, index) => (
						<Slide
							key={`bottle-${index}`}
							ref={(el) => (bottleSlideRefs.current[index] = el)}
						>
							<BottleImageContainer active={index === activeBottleIndex}>
								<BottleImage
									src={
										`/images/us/en/product/${wineData?.product?.itemCode}.png` ||
										'/images/us/common/default_bottle_small.png'
									}
									alt={wineData?.product?.name || 'Wine bottle'}
									style={{
										maxHeight: 'max-content',
									}}
									onError={(e) => {
										e.currentTarget.onerror = null;
										e.currentTarget.src =
											'/images/us/common/default_bottle_small.png';
									}}
								/>
							</BottleImageContainer>
							<SwapIcon
								onClick={(e) => {
									e.stopPropagation();
									handleBottleSwap(index);
								}}
							/>
						</Slide>
					))}
				</Track>
			</TrackWrapper>

			<CarouselNavButton
				onClick={handleNext}
				disabled={activeBottleIndex === wineSlots.length - 1}
				aria-label='Next bottle'
			>
				<svg
					width='44'
					height='44'
					viewBox='0 0 44 44'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M16.5 11L27.5 22L16.5 33'
						stroke='#222222'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			</CarouselNavButton>
		</CarouselContainer>
	);
};

export default MobileBottleCarousel;
